import { useMutation } from "@tanstack/react-query";
import { fetchRfxResponsePreviewHtml } from "../api/rfx-report-api";
import type { RfxResponsePreviewParams, RfxReportPreviewHtmlResponse } from "../types";

export const useRfxResponsePreviewHtml = () => {
	return useMutation<RfxReportPreviewHtmlResponse, Error, { rfxId: number; params: RfxResponsePreviewParams }>({
		mutationFn: ({ rfxId, params }) => fetchRfxResponsePreviewHtml(rfxId, params),
	});
};
